import React from 'react';
import { SeriesDatesDropdownScopedProps } from '../../types';
import { dynaMount } from '../utils/mountComponent';
import SeriesDatesDropdown from './SeriesDatesDropdown';

const SERIES_DESKTOP_ROOT_ID = 'listings-root__series-events-desktop';
const SERIES_MOBILE_ROOT_ID = 'listings-root__series-events-mobile';

const SeriesDatesDropdownDesktopMount = (
    props: SeriesDatesDropdownScopedProps,
): JSX.Element | React.ReactPortal => {
    return dynaMount(
        {
            Component: SeriesDatesDropdown,
            containerId: SERIES_DESKTOP_ROOT_ID,
        },
        props,
    );
};

const SeriesDatesDropdownMobileMount = (
    props: SeriesDatesDropdownScopedProps,
): JSX.Element | React.ReactPortal => {
    return dynaMount(
        {
            Component: SeriesDatesDropdown,
            containerId: SERIES_MOBILE_ROOT_ID,
        },
        props,
    );
};

const SeriesDatesDropdownRoot = (
    props: SeriesDatesDropdownScopedProps,
): JSX.Element | null => {
    return (
        <>
            <SeriesDatesDropdownDesktopMount {...props} />
            <SeriesDatesDropdownMobileMount {...props} />
        </>
    );
};

export default SeriesDatesDropdownRoot;
